export default __webpack_public_path__ + "static/media/combot-blue.412e939c.svg";